import { toDate } from 'date-fns';

export const parseLastAuthenticationDate = (lastAuthentificationDate: number | undefined | null): Date | 'no date' => {
  if (lastAuthentificationDate) {
    const parsedLastAuthentificationDate = toDate(lastAuthentificationDate * 1000);
    return parsedLastAuthentificationDate;
  }
  return 'no date';
};
